import { render, staticRenderFns } from "./dateColumn.vue?vue&type=template&id=488a4586&scoped=true&"
import script from "./dateColumn.vue?vue&type=script&lang=js&"
export * from "./dateColumn.vue?vue&type=script&lang=js&"
import style0 from "./dateColumn.vue?vue&type=style&index=0&id=488a4586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a4586",
  null
  
)

export default component.exports